import axios from 'axios';
const CRITICAL = /\/(fees?|payments?|receipts?|attendance|students?|admission|employees?|hrms|whatsapp|sms|user-management|roles?)(\/|\?|$)/i;
const SAFE_METHODS = new Set(['get', 'head', 'options']);
let pending = 0;
export function isCriticalMutationActive() { return pending > 0; }
export function mutationAllowed(connectivityState) { return !['offline', 'backend-unreachable', 'reconnecting'].includes(connectivityState); }
export function installMutationSafety(getConnectivity) {
  const requests = axios.interceptors.request.use((config) => {
    const method = String(config.method || 'get').toLowerCase(); const critical = !SAFE_METHODS.has(method) && CRITICAL.test(config.url || '');
    if (!critical) return config;
    if (!mutationAllowed(getConnectivity())) return Promise.reject(Object.assign(new Error('This transaction requires a live CoachHub connection.'), { code: 'COACHHUB_OFFLINE_MUTATION' }));
    pending += 1; config.__coachhubCritical = true;
    if (['post', 'put', 'patch'].includes(method) && !config.headers?.['Idempotency-Key']) { config.headers = config.headers || {}; config.headers['Idempotency-Key'] = crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`; }
    return config;
  });
  const finish = (value) => { if (value?.config?.__coachhubCritical) pending = Math.max(0, pending - 1); return value; };
  const responses = axios.interceptors.response.use(finish, (error) => { finish(error); return Promise.reject(error); });
  return () => { axios.interceptors.request.eject(requests); axios.interceptors.response.eject(responses); };
}
